import React from 'react';

const Browser = ({image, children, style = {}}) => {
  return (
    <div className="browser-mockup">
      {children ? (
        <div className="browser-content" style={style}>
          {children}
        </div>
      ) : (
        <img src={image} />
      )}
    </div>
  );
};

export default Browser;


// WEBPACK FOOTER //
// ./src/components/Browser.js